import React from "react";
import { Input } from "@/components/ui/input";
import ExpandField from "@/components/shownotes/ExpandField";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { formatDate } from "@/lib/date";
import NoteSection, { Field, ReadValue } from "@/components/shownotes/NoteSection";

// Section 1: auto-filled header (submitter, report #, managers) plus the template's own fields.
export default function SectionOne({ kind, fields, set, note, submitterName, ctx }) {
  const number = note?.report_number || ctx?.next_number;
  const managers = ctx?.managers?.length ? ctx.managers.join(", ") : "No stage managers in this production yet";
  return (
    <NoteSection title="Report Details" testId="notes-section-details">
      <div className="grid gap-4 sm:grid-cols-2">
        <Field label="Submitted by">
          <ReadValue testId="notes-submitted-by">{note?.author_name || submitterName} on {formatDate(note?.submitted_at || new Date().toISOString())}</ReadValue>
        </Field>
        <Field label="Report Number">
          <ReadValue testId="notes-report-number">
            #{number || "—"}{!note?.report_number && <span className="ml-2 text-xs text-slate-400">assigned on approval</span>}
          </ReadValue>
        </Field>
        <Field label="Date">
          <Input type="date" value={fields.date} onChange={(e) => set({ date: e.target.value })} data-testid="notes-date-input" />
        </Field>
        <Field label="Manager">
          <ReadValue testId="notes-managers">{managers}</ReadValue>
        </Field>
        {kind === "rehearsal" ? (
          <Field label="Space" className="sm:col-span-2">
            <Input value={fields.space} onChange={(e) => set({ space: e.target.value })} data-testid="notes-space-input" />
          </Field>
        ) : (
          <>
            <Field label="House Count">
              <Input value={fields.house_count} onChange={(e) => set({ house_count: e.target.value })} placeholder="e.g. 212" data-testid="notes-house-count-input" />
            </Field>
            <Field label="Standing Ovation">
              <Select value={fields.standing_ovation || undefined} onValueChange={(v) => set({ standing_ovation: v })}>
                <SelectTrigger data-testid="notes-ovation-select"><SelectValue placeholder="Select" /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="yes" data-testid="notes-ovation-yes">Yes</SelectItem>
                  <SelectItem value="no" data-testid="notes-ovation-no">No</SelectItem>
                </SelectContent>
              </Select>
            </Field>
            <ExpandField label="Audience Reaction" wide value={fields.audience_reaction} onChange={(v) => set({ audience_reaction: v })} testId="notes-audience-input" />
          </>
        )}
      </div>
    </NoteSection>
  );
}
